import React from 'react';

const Footer = () => {
  return (
    <div className="footer" id="footer">
      <div className="mapouter"><div className="gmap_canvas"><iframe title="map"id="gmap_canvas" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3321.7198329842704!2d-70.71432092529577!3d-33.63850567331554!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662d8d20f6c2c63%3A0xbed89ac2a0feaeca!2sRegina%20G%C3%A1lvez%20285%2C%20San%20Bernardo%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses-419!2scl!4v1773709781326!5m2!1ses-419!2scl" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"></iframe></div><style></style></div>
      <div className="footer-right-container">
      <div className="footer-right-text">
        <i className="fa fa-whatsapp fa-lg icon"></i>&nbsp;&nbsp;&nbsp;
        <span>WhatsApp al +56 9 9966 8776</span>
        <br></br>
        <br></br>
        <i className="fa fa-map-marker fa-lg icon"></i>&nbsp;&nbsp;&nbsp;
        <span>Regina Gálvez #285, San Bernardo, Región Metropolitana</span>
        <br></br>
        <br></br>
      </div>
      </div>
    </div>
  )
}

export default Footer;